import React from 'react';
import { CompanyDashboardProps } from '../constants';

const { BAR_FILL, LEGEND_TEXT_FILL, LOCATION_BAR_FILL } = CompanyDashboardProps;

export const xAxisLabelContent = () => {
  const squareSize = 16; // Size of the squares

  return (
    <g>
      <rect
        x={'45%'}
        y={'85%'}
        width={squareSize}
        height={squareSize}
        fill={BAR_FILL}
      />
      <text
        x={'50.5%'}
        y={'85%'}
        textAnchor="middle"
        fill={LEGEND_TEXT_FILL}
        dy="0.9em"
        fontSize="0.8rem">
        Organization
      </text>
      <rect
        x={'55%'}
        y={'85%'}
        width={squareSize}
        height={squareSize}
        fill={LOCATION_BAR_FILL}
      />
      <text
        x={'59.5%'}
        y={'85%'}
        textAnchor="middle"
        fill={LEGEND_TEXT_FILL}
        dy="0.9em"
        fontSize="0.8rem">
        Location
      </text>
    </g>
  );
};
